import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { merge as _merge, reduce as _reduce } from 'lodash';
import { RadioDropdown } from '@saucelabs/sl-component-form';
import { Row, Col } from '@saucelabs/sl-component-grid';

import Styles from './VirtualDeviceConfigurator.styles';
import DesktopBrowserConfiguratorTunnel from './../DesktopBrowserConfigurator/DesktopBrowserConfiguratorTunnel';

export const orderDevicesByManufacture = (devices) => {
  const androidDevices = _reduce(devices.android, (acc, value, key) => {
    const [manufacturer, ...deviceNameSplit] = key.split(' ');
    const deviceName = deviceNameSplit.join(' ');

    return _merge(acc, { [manufacturer]: { [deviceName]: value } });
  }, {});

  return {
    ...androidDevices,
    Apple: { ...devices.ios },
  };
};

export const clearSelection = (selection, data) => {
  /* eslint-disable no-param-reassign */
  if (data.manufacturer) {
    selection.device = null;
    selection.os = null;
  }

  if (data.device) {
    selection.os = null;
  }
  /* eslint-enable no-param-reassign */
};

class VirtualDeviceConfigurator extends Component {
  constructor(props) {
    super(props);

    const devicesByManufacturer = orderDevicesByManufacture(props.browsers);
    const manufacturers = Object.keys(devicesByManufacturer).sort();

    this.state = {
      options: devicesByManufacturer,
      manufacturers,
      devices: [],
      oses: [],

      manufacturer: manufacturers[0],
      device: null,
      os: null,
    };
  }

  componentWillMount() {
    this.handleSelection({});
  }

  handleSelection = (data = {}) => {
    const { options, manufacturer, device, os } = this.state;
    const { virtualDeviceConfiguration } = this.props;

    const selection = {
      manufacturer,
      device,
      os,
      ...data,
    };

    clearSelection(selection, data);

    if (!selection.device) {
      selection.devices = Object.keys(options[selection.manufacturer]).sort();
      selection.device = selection.devices[0];
    }

    if (!selection.os) {
      selection.oses = Object.keys(options[selection.manufacturer][selection.device])
        .sort().reverse();
      selection.os = selection.oses[0];
    }

    const configuration = options[selection.manufacturer][selection.device][selection.os] || {};

    const onChangeObj = Object.assign({}, {
      browser: configuration.browser,
      browserDisplay: configuration.device,
      browserVersionDisplay: '',
      device: configuration.device,
      os: configuration.platform,
      osDisplay: configuration.browser,
      osVersionDisplay: configuration.version,
      res: null,
      version: configuration.version,
    });

    virtualDeviceConfiguration.input.onChange(onChangeObj);
    this.setState(selection);
  }

  renderDropdown = (config) => {
    const currentValue = this.state[config.keyName]; // eslint-disable-line
    const onChange = (newValue) => this.handleSelection({ [config.keyName]: newValue });
    const prepareOptions = (options) => options.map((item) => ({
      text: item,
      value: item,
    }));

    return (
      <Row key={config.keyName}>
        <Col xs>
          <RadioDropdown
            initialValue={currentValue}
            input={{
              value: currentValue,
              onChange,
            }}
            isInputForm
            label={config.label}
            options={prepareOptions(config.options)}
          />
        </Col>
      </Row>
    );
  }

  render() {
    const { manufacturers, devices, oses } = this.state;
    const { tunnels } = this.props;
    const DROPDOWNS_CONFIG = [
      {
        label: 'Manufacturer',
        keyName: 'manufacturer',
        options: manufacturers,
      },
      {
        label: 'Device',
        keyName: 'device',
        options: devices,
      },
      {
        label: 'OS version',
        keyName: 'os',
        options: oses,
      },
    ];

    return (
      <div className={Styles.default}>
        <Row>
          <Col
            className={Styles.info}
            xs
          >
            Please select your device. Can’t find your device listed?
            {' '}
            <a
              href="mailto:support@saucelabs.com"
              rel="noopener noreferrer"
              target="_blank"
            >
              Let us know!
            </a>
          </Col>
        </Row>
        <Row>
          <Col xs>
            <div className={Styles['dropdowns-column']}>
              {DROPDOWNS_CONFIG.map(this.renderDropdown)}
              <DesktopBrowserConfiguratorTunnel tunnels={tunnels} />
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

VirtualDeviceConfigurator.propTypes = {
  browsers: PropTypes.object.isRequired,
  tunnels: PropTypes.array.isRequired,
  virtualDeviceConfiguration: PropTypes.object.isRequired,
};

export default VirtualDeviceConfigurator;
